
export const DEFAULT_ICON_SCALE = 32;
export const DEFAULT_ZOOM = -5;
export const SIDEBAR_WIDTH = 400;
export const ISOLATION_FOCUS_ZOOM = 1;


export const BASE_MODULE_SLOT_WIDTH = 512;
export const BASE_MODULE_SLOT_HEIGHT = 512;
export const CELL_WIDTH = 2000;
export const CELL_HEIGHT = 2000;
export const GRID_PADDING = 50;

export const NO_LOCATION_KEY = '_';

export const NORMAL_OPACITY = 0.8;
export const FADED_OPACITY = 0.15;
export const LEAFLET_CRS = (() => {
  const L = window.L;
  if (!L) {
      return null;
  }
  const customCRS = L.CRS.Simple;
  customCRS.transformation = new L.Transformation(2, -0, -2, 0);
  return customCRS;
})();

export const PLACEMENT_PARAMS_BY_SIZE = {
    "512x512": { scaleX: 3.1, scaleY: 2.57, offsetX: 0, offsetY: -320, },
    "512x1024": { scaleX: 3, scaleY: 2.3, offsetX: -0, offsetY: -400, },
    "1024x1024": { scaleX: 3.25, scaleY: 2.5, offsetX: 0, offsetY: 0, },
    "default": { scaleX: 3.1, scaleY: 2.57, offsetX: 0, offsetY: 0, }
};


export const DEFAULT_MODULE_DIMENSIONS = { width: 512, height: 512 };

export const MODULE_DIMENSION_OVERRIDES = {
  "IceCave_Hive_03": { width: 512, height: 1024 },
  "Ruins_TowerBridge_Destroyed": { width: 512, height: 1024 },
  "CenterTower": { width: 1024, height: 1024 },
};


export const MARKER_TRANSFORM_RULES = {
  "Ruins": {
      "Ruins_TowerBridge_Destroyed": {
          originalActorCoordWidth: 512,
          originalActorCoordHeight: 1024,
          rotation: 0,
          flipX: false,
          flipY: false,
          actorOffsetX: 3300,
          actorOffsetY: 0
      }
  },
   "IceCave": {
      "IceCave_Hive_03": {
          originalActorCoordWidth: 512,
          originalActorCoordHeight: 1024,
          rotation: 0,
          flipX: false,
          flipY: false,
          actorOffsetX: 3300,
          actorOffsetY: 0     
      }
   },
  "Crypt": {
      "CenterTower": {
          originalActorCoordWidth: 1024,
          originalActorCoordHeight: 1024,
          rotation: 0,
          flipX: false,
          flipY: false,
          actorOffsetX: 2700,
          actorOffsetY: 0
      }
  }
};